import { render, staticRenderFns } from "./UploadImageIndentification.vue?vue&type=template&id=25c7cb48&scoped=true&"
import script from "./UploadImageIndentification.vue?vue&type=script&lang=ts&"
export * from "./UploadImageIndentification.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImageIndentification.vue?vue&type=style&index=0&id=25c7cb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7cb48",
  null
  
)

export default component.exports